export default __webpack_public_path__ + "static/estate-cleanout-icon-4d6ede1886d00bc86c062b713df41c12.png";